module.exports = __webpack_public_path__ + "img/img-9.cefe1da3.svg";